import { cn } from "@/lib/utils";
import { ReactNode, useEffect, useState } from "react";

interface Props {
  show: boolean;
  index: number;
  children: ReactNode;
}

export default function SearchDropdownWhiteScreen({
  show,
  index,
  children,
}: Props) {
  const [dropdownClasses, setDropdownClasses] = useState(
    "opacity-0 hidden translate-y-16",
  );

  const makeItShow = () => {
    setDropdownClasses("opacity-0 translate-y-16");
    setTimeout(() => {
      setDropdownClasses("opacity-100 flex translate-y-24");
    }, 15);
    return dropdownClasses;
  };

  useEffect(() => {
    if (show) {
      makeItShow();
    } else {
      setDropdownClasses("opacity-0 translate-y-16");
      setTimeout(() => {
        setDropdownClasses("opacity-0 hidden translate-y-16");
      }, 300);
    }
  }, [show]);

  return (
    <div
      id={`search-dropdown-${index}`}
      className={cn(
        "container w-full md:w-[334px] max-md:left-0 !absolute duration-300 top-[-16px] md:top-0 md:rounded-2xl md:shadow-lg bg-white flex-col md:px-6 z-50 md:h-[427px]",
        show && dropdownClasses === "opacity-0 hidden translate-y-16"
          ? makeItShow()
          : dropdownClasses,
      )}
    >
      {children}
    </div>
  );
}
